import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

// Tema claro/oscuro: se aplica antes de pintar para que no haya parpadeo (la preferencia del usuario
// se sincroniza después con su cuenta).
try {
  document.documentElement.dataset.theme = localStorage.getItem('enmarcha-theme') === 'light' ? 'light' : 'dark';
} catch (e) {
  document.documentElement.dataset.theme = 'dark';
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
